import React from "react"
import { useTheme } from "styled-components"
import { SlideContent, Left, Right, Image } from "./styles"

const TestimonialSlide = ({
  elRef,
  author,
  excerpt,
  credentials,
  text,
  image,
  hideOnPageLoad,
  dataId,
}) => {
  const theme = useTheme()
  const sizeDesktopL = theme.component.isNested ? 355 : 440

  return (
    <SlideContent data-exp-id={dataId} hideOnPageLoad={hideOnPageLoad} ref={elRef}>
      <Left>
        <blockquote dangerouslySetInnerHTML={{ __html: excerpt }} />
        <h3>{author}</h3>
        <h5>{credentials}</h5>
        <div dangerouslySetInnerHTML={{ __html: text }} />
      </Left>
      <Right>
        <Image
          baseUrl={image}
          images={[
            {
              screenSize: 992,
              transforms: `c_fill,g_auto,w_${sizeDesktopL},h_${sizeDesktopL},q_auto,f_auto,fl_lossy`,
            },
            {
              screenSize: 769,
              transforms: "c_fill,g_auto,w_270,h_270,q_auto,f_auto,fl_lossy",
            },
            {
              screenSize: 577,
              transforms: "c_fill,g_auto,w_297,h_297,q_auto,f_auto,fl_lossy",
            },
            { transforms: "c_fill,g_auto,w_576,h_576,q_auto,f_auto,fl_lossy" },
          ]}
          lazy={!theme.component.onTop}
        />
      </Right>
    </SlideContent>
  )
}

export default TestimonialSlide
